<template>
  <div class="technology-page">
    <!-- 引用 Technology 组件 -->
    <Technology class="technology-content" />
  </div>
</template>

<script setup>
import { inject, onMounted, onUnmounted } from 'vue';
import Technology from '../components/Technology.vue';

// 注入修改navbar文字颜色的方法
const changeNavbarTextColor = inject('changeNavbarTextColor');

// 组件挂载时将navbar文字颜色改为黑色
onMounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor('#000000', '#000000'); // 改为黑色
  }
});

// 组件卸载时恢复navbar文字颜色为白色
onUnmounted(() => {
  if (changeNavbarTextColor) {
    changeNavbarTextColor('white', 'white'); // 恢复白色
  }
});
</script>

<style scoped>
.technology-page {
  width: 100%;
  min-height: 100vh;
}
.technology-content{
    padding-top:70px;
}
</style>